import vesselReducer from './vessel.reducer'

export default vesselReducer
